"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _log = require("@/utils/log");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _user = require("@/api/user");
var _training = require("@/api/training");
var _lodash = _interopRequireDefault(require("lodash"));
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import * as utils from '@/utils/auth'
// import { writeGaEvent } from '@/utils/ga'
var _default = exports.default = {
  name: 'TrainingStaff',
  components: {
    draggable: _vuedraggable.default
  },
  props: {
    parentId: {
      type: String,
      default: ''
    },
    internalTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loadingUsers: false,
      loadingRoles: false,
      keywordSearch: '',
      staffList: [],
      /* otr staff library */
      coachList: [],
      producerList: [],
      assistantList: []
    };
  },
  computed: {
    fullSelectedList: function fullSelectedList() {
      return _lodash.default.unionWith(this.coachList, this.assistantList, this.producerList);
    },
    loading: function loading() {
      return this.loadingUsers || this.loadingRoles;
    }
  },
  watch: {
    fullSelectedList: {
      handler: function handler(newVal) {
        // showDebugLog('Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal);
      },
      deep: true
    }
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getStaffList();
          case 1:
            if (!(_this.parentId && _this.parentId !== 'copy')) {
              _context.n = 2;
              break;
            }
            _context.n = 2;
            return _this.getStaffByRole();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    /* no code */getStaffByRole: function getStaffByRole() {
      var _this2 = this;
      this.loadingRoles = true;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _training.getTrainingStaff)(token, this.parentId).then(function (response) {
        _this2.loadingRoles = false;
        _this2.coachList = response.data.rows.filter(function (row) {
          return row.role === 'coach';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName)
          };
        });
        _this2.assistantList = response.data.rows.filter(function (row) {
          return row.role === 'assistant';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName)
          };
        });
        _this2.producerList = response.data.rows.filter(function (row) {
          return row.role === 'producer';
        }).map(function (s) {
          return {
            role: s.role,
            user: s.user.uuid,
            name: "".concat(s.user.givenName, " ").concat(s.user.middleName, " ").concat(s.user.familyName)
          };
        });
      }).catch(function (error) {
        _this2.loadingRoles = false;
        (0, _log.showDebugLog)('GetTrainingStaff-api-error', error);
      });
    },
    getStaffList: function getStaffList() {
      var _this3 = this;
      this.loadingUsers = true;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var query = {
        page: 1,
        limit: 100,
        role: 'otr-coach,otr-product-admin,otr-digital-producer',
        sort: 'givenName',
        q: this.keywordSearch
      };
      (0, _user.getUserList)(token, query).then(function (response) {
        // this.list = response.data.items
        _this3.loadingUsers = false;
        _this3.staffList = response.data.rows.map(function (s) {
          return {
            role: '',
            user: s.uuid,
            name: "".concat(s.givenName, " ").concat(s.middleName, " ").concat(s.familyName),
            sysRole: s.role
          };
        });
      }).catch(function (error) {
        _this3.loadingUsers = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    isDproducer: function isDproducer(sysRoleArray) {
      return _lodash.default.indexOf(sysRoleArray, 'otr-digital-producer') > -1;
    },
    cloneLibrary: function cloneLibrary(e) {
      return {
        role: e.role,
        user: e.user,
        name: e.name,
        sysRole: e.sysRole
      };
    },
    updateLibrary: function updateLibrary(evt) {},
    updateCoachList: function updateCoachList(evt) {
      this.coachList = _lodash.default.uniqBy(this.coachList, 'user');
      (0, _log.showDebugLog)('training-dragdrop-coach', evt);
      if (evt.added) {
        evt.added.element.role = 'coach';
      }
    },
    updateAssitantList: function updateAssitantList(evt) {
      this.assistantList = _lodash.default.uniqBy(this.assistantList, 'user');
      (0, _log.showDebugLog)('training-dragdrop-assistant', evt);
      if (evt.added) {
        evt.added.element.role = 'assistant';
      }
    },
    updateProducerList: function updateProducerList(evt) {
      this.producerList = _lodash.default.uniqBy(this.producerList, 'user');
      (0, _log.showDebugLog)('training-dragdrop-producer', evt);
      if (evt.added) {
        evt.added.element.role = 'producer';
      }
    },
    removeCoach: function removeCoach(idx, clist) {
      clist.splice(idx, 1);
    },
    removeAssistant: function removeAssistant(idx, alist) {
      alist.splice(idx, 1);
    },
    removeProducer: function removeProducer(idx, plist) {
      plist.splice(idx, 1);
    },
    passBackToParent: function passBackToParent(staff) {
      if (staff) {
        this.$emit('updateParentStaff', staff);
      } else {
        this.$emit('updateParentStaff', []);
      }
    }
  }
};